import { render, staticRenderFns } from "./ImportAssembly.vue?vue&type=template&id=0aa15891&scoped=true"
import script from "./ImportAssembly.vue?vue&type=script&lang=ts"
export * from "./ImportAssembly.vue?vue&type=script&lang=ts"
import style0 from "./ImportAssembly.vue?vue&type=style&index=0&id=0aa15891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa15891",
  null
  
)

export default component.exports